define('connections/offer-connection',['jquery', 'utils/ajax-util', 'settings'], function ($, ajax, settings) {
  /**
   * @class Cart
   */
  return (function () {
    /**
     * @constructor
     */
    function OfferConnection() { }

    /**
     * Add items to offer by posting sku- and quantity lists
     *
     * @method add
     * @param  {Array}     - A list of objects of the format: { sku: sku, quantity: quantity }.
     * @return {Promise}   - A jQuery ajax promise.
     */
    OfferConnection.prototype.add = function (data) {
      return ajax.post(settings.offer + 'addtooffer', data);
    };

    /**
     * Change quantity on sku(s)
     *
     * @method change
     * @param  {Object} data   - Format: { id: offerId, sku: sku, quantity: quantity }
     * @returns {promise}
     */
    OfferConnection.prototype.changeQuantity = function (data) {
      return ajax.post(settings.offer + 'changeitemquantity', data);
    };

    /**
     * Delete product
     *
     * @method deleteProduct
     * @param  {Object} data   - Format: { id: offerId, productId: productId }
     * @returns {*}
     */
    OfferConnection.prototype.deleteProduct = function (data) {
      return ajax.delete(settings.offer + 'deleteproduct', data);
    };

    /**
     * Set or change product comment.
     * @param  {String} productId
     * @param  {Object} data   - Format: { id: offerId, productId: productId, comment: comment }
     * @return {Promise}       - A jQuery ajax promise.
     */
    OfferConnection.prototype.changeComment = function (data) {
      return ajax.post(settings.offer + 'setproductcomment', data);
    };

    /**
     * Set or change the date of the offer expiration.
     * @param  {Object} data   - Format: { id: offerId, date: date, offset: offset }
     * @return {Promise}       - A jQuery ajax promise.
     */
    OfferConnection.prototype.changeExpiration = function (data) {
      return ajax.post(settings.offer + 'setexpiration', data);
    };

    /**
     * Set or change the percent of a specific row.
     * @param  {Object} data   - Format: { id: offerId, productId: productId, margin: margin }
     * @return {Promise}         - A jQuery ajax promise.
     */
    OfferConnection.prototype.changePercent = function (data) {
      return ajax.post(settings.offer + 'setpercent', data);
    };

    /**
     * Sets or changes the price of the row.
     * @param  {Object} data   - Format: { id: offerId, productId: productId, price: price }
     * @return {Promise} a - jQuery ajax promise.
     */
    OfferConnection.prototype.changeProductPrice = function (data) {
      return ajax.post(settings.offer + 'setnewproductprice', data);
    };

    OfferConnection.prototype.changeSkuPrice = function (data) {
      return ajax.post(settings.offer + 'setnewskuprice', data);
    };

    /**
     * Sets or changes the image references for logo application.
     * @param  {Object} data   - Format: { id: offerId, productId: productId, logoImages: [ logoId1, logoId2, ... ] }
     * @return {Promise}         - A jQuery ajax promise.
     */
    OfferConnection.prototype.changeLogoApplication = function (data) {
      return ajax.post(settings.offer + 'setlogoapplication', data);
    };

    /**
     * Sets or changes the cost rows. Will also be used for application cost with the name prefilled.
     * @param  {Object} data   - Format: { id: offerId, productId: productId, costRows: [ { name: name, cost: cost, quantity: quantity }, ... ] }
     * @return {Promise}       - A jQuery ajax promise.
     */
    OfferConnection.prototype.changeCostRows = function (data) {
      return ajax.post(settings.offer + 'setcostlines', data);
    };

    /**
     * Get a list off all the customers saved offers.
     * @return {Promise} - a jQuery ajax promise.
     */
    OfferConnection.prototype.getOfferHeaders = function () {
      return ajax.get(settings.offer + 'list');
    };

    /**
     * Removes the specified offer from the customer.
     * @param  {String} id - the id of the offer.
     * @return {Promise}   - A jQuery ajax promise.
     */
    OfferConnection.prototype.removeOffer = function (id) {
      return ajax.delete(settings.offer + 'delete', { offerId: id });
    };

    OfferConnection.prototype.addProduct = function (id, sku) {
      return ajax.post(settings.offer + 'addproduct', { offerId: id, sku: sku });
    };

    OfferConnection.prototype.getSum = function (id) {
      return ajax.post(settings.offer + 'getsum', { offerId: id });
    };

    OfferConnection.prototype.changeName = function (id, newName) {
      return ajax.post(settings.offer + 'changename', { offerId: id, name: newName });
    };

    /**
     * Loads all the skus to the cart.
     * @param  {String} id - the id of the offer.
     * @return {Promise}   - A jQuery ajax promise.
     */
    OfferConnection.prototype.addProductsToCart = function (id) {
      return ajax.get(settings.offer + 'addproductstocart?offerId=' + id);
    };

    OfferConnection.prototype.createPublicUrl = function (id) {
      return ajax.get(settings.offer + 'createpublicurl?offerId=' + id);
    };

    OfferConnection.prototype.removePublicUrl = function (id) {
      return ajax.get(settings.offer + 'removepublicurl?offerId=' + id);
    };

    OfferConnection.prototype.updateViewSettings = function (formData) {
      return ajax.ajaxWithFormData(settings.offer + 'updateviewSettings', formData);
    };

    OfferConnection.prototype.getOfferPdfPreview = function (id) {
      return ajax.get(settings.offer + 'getofferpdfpreview?offerId=' + id);
    };

    return new OfferConnection();
  })();
});

